import React, {FC, useEffect} from "react";
import momentTz from "moment-timezone";
import {useGetAppSettingsQuery} from "../../generated/graphql";
import {DEFAULT_ORGANIZATION_TIMEZONE, isOrganizationTimezone} from "../../../shared/timezone";

type TimezoneBootstrapProps = {
    children: React.ReactNode;
};

/**
 * Setzt die globale moment-timezone Default-Zeitzone basierend auf den App-Einstellungen.
 * Muss innerhalb von ApolloWrapper gerendert werden, da useGetAppSettingsQuery
 * den Apollo Client benötigt.
 */
const TimezoneBootstrap: FC<TimezoneBootstrapProps> = ({children}) => {
    const {data} = useGetAppSettingsQuery();
    const timezone = isOrganizationTimezone(data?.settings?.timezone) ? data.settings.timezone : DEFAULT_ORGANIZATION_TIMEZONE;

    useEffect(() => {
        momentTz.tz.setDefault(timezone);
    }, [timezone]);

    return <>{children}</>;
};

export default TimezoneBootstrap;
